export default "__VITE_ASSET__80e04bf4__"